import React from "react";
import PropTypes from "prop-types";
import { Carousel } from "react-responsive-carousel";
import { Segmant } from "../../components";
import Slider from "react-slick";
import { NewItemData } from "../../components";
import { Grid, Divider, Icon, Dropdown, Loader } from "semantic-ui-react";

const rateoptions = [
  {
    key: "1",
    text: "1",
    value: "1",
  },
  {
    key: "2",
    text: "2",
    value: "2",
  },
  {
    key: "3",
    text: "3",
    value: "3",
  },
  {
    key: "4",
    text: "4",
    value: "4",
  },
  {
    key: "5",
    text: "5",
    value: "5",
  },
];

const Gallery = ({
  imageData,
  selectedItem,
  user_id,
  is_editor,
  removephoto,
  editphotocaption,
  onRatemodal,
  is_static,
  modalhelpful,
  isloaderactive,
  ismodalopen,
  nhid,
  islistingmodalopen,
}) => {
  let icons = process.env.NEXT_PUBLIC_CDN_ID + "static/images/icon.jpg";

  const checkdimension = (imgheight) => {
    let modalbox = document.querySelector(".ReactModal__Content");
    if (modalbox !== undefined && modalbox !== null) {
      return modalbox.offsetHeight - 125 + "px";
      // if (imgheight < modalbox.offsetHeight) {
      //   return modalbox.offsetHeight - 125 + "px";
      // } else {
      //   return "auto";
      // }
    }
  };
  return (
    <div>
      <Segmant className="pr-0 popup_slider">
        {islistingmodalopen ? (
          <Carousel
            showIndicators={true}
            infiniteloop={true}
            autoPlay={false}
            interval={2000}
            // onClickItem={(e) => openpopup(e, length)}
            selectedItem={selectedItem}
          >
            {imageData &&
              ismodalopen === true &&
              imageData.map((image, index) => {
                let img = new Image();
                img.src = image;
                let imgheight = checkdimension(img.height);
                // }
                return (
                  <div
                    key={index}
                    id={`imgdata${index}`}
                    style={{
                      height: imgheight && imgheight,
                      //width: image.username && "80%",
                    }}
                  >
                    <img
                      src={image}
                      id={`imgdataslider${index}`}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src =
                          process.env.NEXT_PUBLIC_CDN_ID +
                          "static/images/homedefault.jpg";
                      }}
                      style={{ height: imgheight && imgheight }}
                      title="home pic"
                      alt="Home Pitcure"
                    />
                  </div>
                );
              })}
          </Carousel>
        ) : (
          <>
            <Loader active inline="centered" size="massive" />
          </>
        )}
      </Segmant>
    </div>
  );
};
Gallery.propTypes = {
  imageData: PropTypes.array.isRequired,
  button: PropTypes.bool,
};
export default Gallery;
